import React from 'react';
import { useEffect, useState } from "react";
import "../../../assets/css/master.css"
import { getAllData, postUsersData, verifytoken } from '../../../services/ApiCallingUserServices';
import Switch from 'react-switch';
import { onlyAlphabets } from '../../commonClass/CommonValidation'
import { useNavigate } from 'react-router-dom';
import { ClearLocalStorage, GetLocalStorage } from '../../commonClass/Session';
import { useDispatch, useSelector } from "react-redux";
import { loaderActions } from "../../../_actions/loader.actions";
import { ConfirmationModal } from '../../../customControl/ConfirmationModal';
import CustomTable from '../../../customControl/CustomTable';
import CommonFilter from '../../../customControl/CommonFilter';

const BankMaster = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [modalShow, setModalShow] = useState(false);
    const [activeId, setActiveId] = useState();
    const [buttonaddeditText, setButtonAddEditText] = useState("Add");
    const [disabled, setDisabled] = useState(false);
    const [editdisabled, setEditDisabled] = useState(true);
    const [formValue, setFormValue] = useState(
        {
            BankMasterId: 0,
            BankName: "",
            IsActive: false,
            UserId: 0
        }
    );
    const [bankList, setBankList] = useState([]);
    const [filterList, setFilterList] = useState([]);
    const [formError, setFormError] = useState([]);

    const [searchvalue, setSearchValue] = useState('');
    const [searchby, setSerachBy] = useState('All');
    const [searchDisabled, setSearchDisable] = useState(false);

    const user = useSelector(store => store.userstatus.tba);
    const [useradd, setUserAdd] = useState(true);
    const [useredit, setUserEdit] = useState(true);
    const [userexport, setUserExport] = useState(true);

    //#region Function for Calling API "getallbanklist" for Table Data
    const getallbanklist = async () => {
        const allbanklist = await getAllData("/master/v1/getallbanklist");
        if (allbanklist?.status) {
            allbanklist?.data?.map((obj) => {
                obj.Active = obj?.isActive === true ? "Active" : "InActive"
            })
            setBankList(allbanklist?.data ? allbanklist?.data : []);
            setFilterList(allbanklist?.data ? allbanklist?.data : []);
        }
        else {
            setBankList([]);
            setFilterList([]);
        }
    }
    //#endregion

    //#region useEffects for API calling
    useEffect(() => {
        dispatch(loaderActions.start());
        let token = GetLocalStorage();
        if (token && token.userName && token.token) {
            let user = GetLocalStorage()
            setFormValue((form) => ({ ...form, UserId: user?.userMasterID }))
            getallbanklist().then(() => { dispatch(loaderActions.end()) });
        }
        else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }

        async function fetchData() {
            dispatch(loaderActions.start());
            let statusoftoken = await verifytoken();
            if (statusoftoken) {
                let user = GetLocalStorage()
                setFormValue((form) => ({ ...form, UserId: user?.userMasterID }));
                getallbanklist();
                dispatch(loaderActions.end());
            }
            else {
                ClearLocalStorage();
                dispatch(loaderActions.end());
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
            }
        }
        fetchData();

    }, []);
    //#endregion

    //#region handle Rights
    useEffect(() => {
        let pagelink = user?.find(x => x?.PageLink?.toLowerCase() === window?.location?.pathname?.toLowerCase());
        let mid = user?.find(x => x?.MenuId === pagelink?.MenuId);
        if (mid?.URightView === false && mid?.URightView !== undefined) {
            navigate('/dashboard');
        }
        user?.filter(x => x.MenuId === pagelink.MenuId).map((obj) => {
            setUserAdd(obj.URightAdd);
            setUserEdit(obj.URightEdit);
            setUserExport(obj.URightExport);

        });
    }, [user])
    //#endregion

    //#region Table Columns
    const columns = [
        {
            name: 'Bank name',
            key: 'bankName',
            sortable: true,
            float: "left",
            selector: (data) => data?.bankName,
        },
        {
            name: 'Active',
            key: 'Active',
            sortable: true,
            float: "left",
            selector: (data) => data?.Active
        },
        {
            name: 'Edit',
            selector: (data) => <button type='button' className='border-0 p-0 bg-body set_disableclr' disabled={!useredit}><i className="fa fa-edit" onClick={() => handleEditViewMode("Edit", data?.bankMasterId)}></i></button>
        },
        {
            name: 'View',
            selector: (data) => <i className="fa fa-eye" onClick={() => handleEditViewMode("View", data?.bankMasterId)}></i>
        }
    ];
    //#endregion

    //#region Validate Data
    const validateData = () => {
        let status = true;
        let error = {};
        if (formValue.BankName?.trim()?.length <= 0) {
            error.BankName = "Please Provide Bank Name.";
            status = false;
        }
        bankList?.forEach((ele) => {
            if (ele?.bankMasterId !== formValue.BankMasterId && formValue.BankName && ele?.bankName?.trim() === formValue.BankName?.trim()) {
                error.BankName = "Bank Name is already exists.";
                status = false;
            }
        })

        if (Object.keys(error)?.length > 0) {
            let id = Object.keys(error)[0];
            document.getElementById(id)?.focus();
        }
        setFormError(error)
        return status;
    }
    //#endregion

    //#region Edit/View Button Function
    const handleEditViewMode = (type, id) => {
        setSearchDisable(true);
        setDisabled(type === "Edit" ? false : true);
        setEditDisabled(false);
        setButtonAddEditText(type === "Edit" ? "Update" : "Add");
        RetriveData(id);
    }
    //#endregion


    //#region Retrive Data on Edit/View
    function RetriveData(id) {
        setFormError([]);

        bankList?.forEach(ele => {
            if (ele?.bankMasterId === id) {
                formValue.BankMasterId = ele?.bankMasterId
                formValue.BankName = ele?.bankName
                formValue.IsActive = ele?.isActive
                setActiveId(ele?.isActive);
            }
        });
        setFormValue({ ...formValue, formValue });
    }
    //#endregion

    //#region Add/Update Button Function
    const handleAddClick = async () => {
        if (validateData()) {
            dispatch(loaderActions.start());
            let statusoftoken = await verifytoken();
            if (statusoftoken) {
                let data = { ...formValue, BankName: formValue.BankName?.trim() }
                const insertupdatebank = await postUsersData("/master/v1/insertupdatebank", data);
                if (insertupdatebank?.status) {
                    clear();
                    getallbanklist();
                    dispatch(loaderActions.end());
                }
                dispatch({ type: 'ALERTING', message: insertupdatebank.message })
            }
            else {
                ClearLocalStorage();
                dispatch(loaderActions.end());
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
            }
        }
    }
    //#endregion

    //#region On Change Methods
    const onChange = (name, value) => {
        setFormError([])
        setEditDisabled(true);
        setFormValue({ ...formValue, [name]: value });
    };
    const handleisActive = (e) => {
        if (buttonaddeditText === 'Add') {
            setFormError([])
            setEditDisabled(true);
            setFormValue((form) => ({ ...form, IsActive: e }))
            setActiveId(!activeId)
        }
        else {
            setModalShow(true);
        }
    }

    const handleConfirmation = (name, e) => {
        if (e === true) {
            setFormError([])
            setEditDisabled(true);
            if (name === "Active") {
                setFormValue((form) => ({ ...form, IsActive: !activeId }))
                setActiveId(!activeId)
                setModalShow(false);
            }
        }
        else {
            setModalShow(false);
        }
    }
    //#endregion

    //#region handle clear operation
    const handleClearClick = () => {
        clear();
    }
    function clear() {
        setFormError([])
        setFormValue((form) => ({
            ...form,
            BankMasterId: 0,
            BankName: "",
            IsActive: false
        }))
        setActiveId(false);
        getallbanklist();
        setButtonAddEditText('Add');
        setDisabled(false);
        setEditDisabled(true);
        setSearchDisable(false);
        setSearchValue("");
        setSerachBy("All");
    }
    //#endregion


    return (
        <>
            <div className="container-fluid mt-4 heading_color">
                <h3>Bank Master</h3>
            </div>
            <div className="container-fluid form_border py-5 my-3">
                <form action="" >
                    <div className="mb-3 row mx-1">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="row">
                                <div className='col-6'>
                                    <div className='row'>
                                        <div className="col-lg-3 col-md-12 col-sm-12 mb-lg-1">
                                            <label for="inputPassword6" className="col-form-label required">Create Bank</label>
                                        </div>
                                        <div className="col-lg-9 col-md-12 col-sm-12 mb-lg-1">
                                            <input
                                                type="text"
                                                id="BankName"
                                                name="BankName"
                                                className='form-control'
                                                value={formValue.BankName}
                                                onChange={(e) => {
                                                    e.target.value?.length <= 75 &&
                                                        onChange(e.target.name, onlyAlphabets(e.target.value))
                                                }}
                                                disabled={disabled ? true : false}
                                                placeholder="Create Bank"
                                                maxLength={75}
                                            />
                                            {formError?.BankName && <div className="text-danger text-start"> {formError?.BankName} </div>}
                                        </div>
                                    </div>
                                </div>

                                <div className='col-3'>
                                    <div className='row align-items-center'>
                                        <div className="col-lg-6 col-md-12 col-sm-12">
                                            <label className="col-form-label">Active</label>
                                        </div>
                                        <div className="col-lg-6 col-md-12 col-sm-12" disabled={false}>
                                            <Switch
                                                onChange={handleisActive}
                                                checked={activeId}
                                                className="react-switch"
                                                disabled={disabled ? true : false}
                                            />
                                        </div>
                                        <ConfirmationModal
                                            show={modalShow}
                                            onHide={() => setModalShow(false)}
                                            noconfirm={() => handleConfirmation("Active", false)}
                                            yesconfirm={() => handleConfirmation("Active", true)}
                                        />
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-center mb-4">
                        {useradd === false && buttonaddeditText === "Add" ?
                            <button type="button" className="btn btn-primary mx-1" id="btnAdd" onClick={handleAddClick} disabled={!useradd}>{buttonaddeditText}</button> :
                            <button type="button" className="btn btn-primary mx-1" id="btnAdd" onClick={handleAddClick} disabled={editdisabled ? false : true}>{buttonaddeditText}</button>}
                        <button type="button" className="btn btn-primary mx-1" id="btnClear" onClick={handleClearClick} >Clear</button>
                    </div>

                    <CommonFilter
                        columns={columns}
                        filterList={filterList}
                        searchDisabled={searchDisabled}
                        getdata={getallbanklist}
                        setlistdata={setBankList}
                        searchvalue={searchvalue}
                        setSearchValue={setSearchValue}
                        searchby={searchby}
                        setSerachBy={setSerachBy}
                    />

                    <CustomTable
                        className="last_two_column_freeze freezEditViewAtLast"
                        columns={columns}
                        data={bankList}
                    />
                </form>
            </div>
        </>
    )
}

export default BankMaster